import * as Types from "./typesActions";

export default {
  gridNiveis: {
    api: '/proc/portal.obter_papeis_aplicacao',
    limits: [5, 15, 20, 30, 50],

    headers: [
      { label: 'Descrição', prop: 'descricao', sortable: true }
    ],

    tooltipMsg: { doubleClick: "Clique duas vezes para alterar" },

    isSelectable: true,
    arrayOfSelected: [],
    typeWasSelected: Types.WAS_SELECTED,

    isDoubleClick: true,
    wasDoubleClick: {
      click: 0,
      object: {}
    },
    typeWasDoubleClick: Types.WAS_DOUBLE_CLICK,

    search: 0,
    typeSearch: Types.SEARCH
  },

  gridUsuarios: {
    api: '/proc/portal.obter_usuarios',
    limits: [5, 15, 20, 30, 50],
    headers: [
      { label: 'Id', prop: 'erpId', sortable: true },
      { label: 'Fornecedor', prop: 'fornecedor', sortable: true },
      { label: 'Nome', prop: 'nome', sortable: true },
      { label: 'Login', prop: 'nomeUsuario' },
      { label: 'Inativação', prop: 'inativacao' }
    ],
    tooltipMsg: { doubleClick: "Clique duas vezes para alterar" },
    isDoubleClick: true,
    wasDoubleClick: {
      click: 0,
      object: {}
    },
    search: 0,
    typeSearch: Types.SEARCH,
    typeWasDoubleClick: Types.WAS_DOUBLE_CLICK
  },
  gridUsuariosVinculados: {
    api: '/proc/portal.obter_usuarios_papel',
    limits: [3, 10, 15, 20],
    headers: [
      { label: 'Código/Login', prop: 'nomeUsuario'},
      { label: 'Fornecedor', prop: 'fornecedor' }
    ],
    search: 0,
    typeSearch: Types.SEARCH
  },
  inputDescription: {
    tags: [],
    value: "",
    typeChangedValue: Types.CHANGED_VALUE,
    typeChanged: Types.CHANGED_DESCRIPTION
  },

  selectTreeModalResources: {
    options: [],
    selected: [],
    typeChanged: Types.CHANGED_SELECTED_RESOURCES,
    typeLoadResources: Types.LOAD_RESOURCES,
  },

  selectApplications: {
    options: [],
    selected: [],
    typeChanged: Types.CHANGED_SELECTED_APPLICATIONS,
    typeLoadApplications: Types.LOAD_APPLICATIONS,
  },

  filtersPanelApplications: {
    body: {},
    search: 0,
    fields: {
      Idaplicacao: {
        component: "Select",
        col: 6,
        title: "Selecione a aplicação",
        api: "/aplicacoes",
        _api: "/aplicacoes",
        options: [],
      },
    },
    typeChangedBody: Types.CHANGED_PANEL_BODY,
    typeSearch: Types.SEARCH_PANEL_FILTERS,
  }
}
